import React from 'react';
import { CheckCircle, AlertCircle, XCircle, X } from 'lucide-react';

const ICONS = {
  success: { icon: CheckCircle, bg: 'bg-green-100', color: 'text-green-600' },
  error: { icon: XCircle, bg: 'bg-red-100', color: 'text-red-600' },
  warning: { icon: AlertCircle, bg: 'bg-amber-100', color: 'text-amber-600' },
  info: { icon: AlertCircle, bg: 'bg-blue-100', color: 'text-blue-600' }
};

const AlertModal = ({ open, onClose, title, message, type = 'info' }) => {
  if (!open) return null;

  const config = ICONS[type] || ICONS.info;
  const Icon = config.icon;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-sm"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full ${config.bg} flex items-center justify-center flex-shrink-0`}>
              <Icon size={20} className={config.color} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-bold text-gray-800">{title}</h3>
              <p className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{message}</p>
            </div>
            <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0 ml-2">
              <X size={16} className="text-gray-400" />
            </button>
          </div>
          <div className="mt-5 flex justify-end">
            <button
              onClick={onClose}
              className="px-5 py-2 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-900 transition-colors"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
